import {
    afterNextRender,
    Component,
    computed,
    inject,
    signal,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChatTooltipComponent } from "../chat-tooltip/chat-tooltip.component";
import { Icon } from "@malirang/front-share";
import { CenterStore } from "../../../../../stores/center/center.store";
import { Router, RouterLink } from "@angular/router";
import { injectNavigationEnd } from "ngxtension/navigation-end";
import { GuardStore } from "../../../../../guards/guard.store";
import { CdkObserveContent } from "@angular/cdk/observers";

@Component({
    selector: "app-create-child-completeness",
    templateUrl: "./create-child-completeness.component.html",
    styleUrls: [
        "./create-child-completeness.component.css",
        "../center-completeness.component.css",
    ],
    imports: [
        CommonModule,
        ChatTooltipComponent,
        Icon,
        RouterLink,
        CdkObserveContent,
    ],
})
export class CreateChildCompletenessComponent {
    readonly centerStore = inject(CenterStore);
    readonly router = inject(Router);
    readonly guardStore = inject(GuardStore);

    completenessError = this.guardStore.completenessError;
    currentCenter = this.centerStore.currentCenter;
    completeness = computed(() => this.currentCenter()?.completeness);

    navigationEnd$ = injectNavigationEnd();

    open = signal(false);

    setStyleFlag = computed(
        () =>
            this.completenessError() === "2" ||
            (!this.completeness()?.createChild &&
                this.completeness()?.createService),
    );

    constructor() {
        afterNextRender(() => {
            this.openTooltip();

            this.navigationEnd$.subscribe(() => {
                this.open.set(false);
                this.openTooltip();
                this.handleError();
            });

            this.guardStore.completenessError$.subscribe({
                next: () => {
                    this.handleError();
                },
            });
        });
    }

    handleError() {
        const error = this.completenessError();
        const url = this.router.url;
        if (
            error === "2" &&
            (url.includes("/child/find") || url.includes("/child/form"))
        ) {
            this.guardStore.setCompletenessError(null);
            return;
        }
    }

    openTooltip() {
        const url = this.router.url;

        if (url.includes("/child/find")) {
            this.open.set(true);
        }
    }
}
